/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable max-len */
/* eslint-disable max-lines */
import { AccessoryData } from '../types';


export type AccessoriesDataCallback = () => Record<string, AccessoryData>;

export interface AccessoryOptions {
  callback?: AccessoriesDataCallback;
}

export class AccessoriesItemData {
  private static instance: AccessoriesItemData;
  private data: Record<string, AccessoryData> = {};
  private callback: AccessoriesDataCallback | null = null;

  constructor (options?: AccessoryOptions) {
  	if (options?.callback) {
  		this.callback = options.callback;
  		this.loadData();
  	}
  }

  static getInstance (options?: AccessoryOptions): AccessoriesItemData {
  	if (!AccessoriesItemData.instance) {
  		AccessoriesItemData.instance = new AccessoriesItemData(options);
  	}
  	return AccessoriesItemData.instance;
  }

  /**
   * Set the callback function that provides the accessories data
   */
  static setCallback (callback: AccessoriesDataCallback): void {
  	AccessoriesItemData.getInstance().callback = callback;
  	AccessoriesItemData.getInstance().loadData();
  }

  /**
   * Get all accessories data
   */
  static getData (): Record<string, AccessoryData> {
  	return AccessoriesItemData.getInstance().data;
  }

  /**
   * Get accessory data by SKU
   */
  static findBySku (sku: string): AccessoryData | null {
  	return AccessoriesItemData.getInstance().data[sku] || null;
  }

  /**
   * Get accessory data by ID
   */
  static findById (id: string): AccessoryData | null {
  	const instance = AccessoriesItemData.getInstance();
  	return Object.values(instance.data).find((component) => component.id === id) || null;
  }

  /**
   * Get all SKUs
   */
  static getAllSkus (): string[] {
  	return Object.keys(AccessoriesItemData.getInstance().data);
  }

  /**
   * Add or update an accessory
   */
  static addAccessory (sku: string, componentData: AccessoryData): void {
  	AccessoriesItemData.getInstance().data[sku] = componentData;
  }

  /**
   * Remove an accessory
   */
  static removeAccessory (sku: string): boolean {
  	const instance = AccessoriesItemData.getInstance();
  	if (instance.data[sku]) {
  		delete instance.data[sku];
  		return true;
  	}
  	return false;
  }

  /**
   * Load data using the registered callback
   */
  private loadData (): void {
  	if (this.callback) {
  		const rawData = this.callback();
  		// Ensure msrp is a number (API might return strings)
  		this.data = Object.fromEntries(
  			Object.entries(rawData).map(([sku, item]) => [
  				sku,
  				{ ...item, msrp: Number(item.msrp) || 0 }
  			])
  		);
  	}
  }

  /**
   * Reload data
   */
  static reload (): void {
  	AccessoriesItemData.getInstance().loadData();
  }

  /**
   * Clear all data
   */
  static clear (): void {
  	AccessoriesItemData.getInstance().data = {};
  }
}


// import { adjustmentType } from '../enums';
// import { AccessoryAssetData } from '../types';

// export const accessoryAssets: Record<string, AccessoryAssetData> = {
// 	'ASADO-ACC': {
// 		sku: 'ASADO-ACC',
// 		description: 'Coyote Asado Accessory Bundle',
// 		msrp: 299,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'ASADO-CT': {
// 		sku: 'ASADO-CT',
// 		description: 'Coyote Chicken Throne',
// 		msrp: 59,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'ASADO-CVRG': {
// 		sku: 'ASADO-CVRG',
// 		description: 'COYOTE Asado Cover Gray',
// 		msrp: 109,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'ASADO-GG': {
// 		sku: 'ASADO-GG',
// 		description: 'Coyote Grid Grippers',
// 		msrp: 49,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'ASADO-HD': {
// 		sku: 'ASADO-HD',
// 		description: 'Coyote Asado Heat Deflector',
// 		msrp: 99,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'ASADO-PS': {
// 		sku: 'ASADO-PS',
// 		description: 'Coyote Pizza Stone',
// 		msrp: 79,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C1BLOW1200': {
// 		sku: 'C1BLOW1200',
// 		description: '1200 CFM blower compatible with Coyote Hood.',
// 		msrp: 699,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C1CHCS-CT': {
// 		sku: 'C1CHCS-CT',
// 		description: 'Coyote Asado Smoker Cart Only',
// 		msrp: 429,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C1ELCT21': {
// 		sku: 'C1ELCT21',
// 		description: 'Coyote Pedestal Cart for Single Burner Electric Grill',
// 		msrp: 299,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C1FLUE10': {
// 		sku: 'C1FLUE10',
// 		description: 'Flue compatible with Coyote Hood. For ceilings 8’6″ to 9’8″',
// 		msrp: 499,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C1FLUE12': {
// 		sku: 'C1FLUE12',
// 		description: 'Flue compatible with Coyote Hood. For ceilings 9’8″ to 12′',
// 		msrp: 709,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C1FLUE8': {
// 		sku: 'C1FLUE8',
// 		description: 'Flue compatible with Coyote Hood. For ceilings 8′ to 8’5″',
// 		msrp: 409,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C1GRDL': {
// 		sku: 'C1GRDL',
// 		description: 'Coyote 14" Griddle. Compatible with grill models: C1C28, C1C34, C1C36, C1S(L)36, C1SL42, C1HY50, C2C36, C2C42, C2SL30, C2SL36, C2SL42',
// 		msrp: 529,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C1HOOD36': {
// 		sku: 'C1HOOD36',
// 		description: '36 Inch Wall Mount Ducted Hood with 1200 CFM Capable (Blower not Included), Halogen Lights, in Stainless Steel',
// 		msrp: 1899,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C1HOOD42': {
// 		sku: 'C1HOOD42',
// 		description: '42 Inch Wall Mount Ducted Hood with 1200 CFM Capable (Blower not Included), Halogen Lights, in Stainless Steel',
// 		msrp: 2199,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C1HOOD48': {
// 		sku: 'C1HOOD48',
// 		description: '48 Inch Wall Mount Ducted Hood with 1200 CFM Capable (Blower not Included), Halogen Lights, in Stainless Steel',
// 		msrp: 2499,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C1LINER36': {
// 		sku: 'C1LINER36',
// 		description: '36"W X 30"D Insert',
// 		msrp: 1799,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C1LINER42': {
// 		sku: 'C1LINER42',
// 		description: '42"W X 30"D Insert',
// 		msrp: 1999,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C1LINER48': {
// 		sku: 'C1LINER48',
// 		description: '48"W X 30"D Insert',
// 		msrp: 2149,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C1PZCART': {
// 		sku: 'C1PZCART',
// 		description: 'Cart for Pizza Oven Includes Tool Holder that mounts to the side',
// 		msrp: 799,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C1PZHCART': {
// 		sku: 'C1PZHCART',
// 		description: 'Cart For Coyote Hybrid Pizza Oven',
// 		msrp: 699,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3-CCVR30-BIG': {
// 		sku: 'C3-CCVR30-BIG',
// 		description: 'COYOTE Gray Cover For 30" Built-In C & SL Series Grill',
// 		msrp: 99,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3-CCVR30-CTG': {
// 		sku: 'C3-CCVR30-CTG',
// 		description: 'COYOTE Gray Cover For 30" Freestanding C & SL Series Grill',
// 		msrp: 149,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3BRIQ30': {
// 		sku: 'C3BRIQ30',
// 		description: 'COYOTE Briquette Set For 30" Gas Grills',
// 		msrp: 199,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3BRIQ34': {
// 		sku: 'C3BRIQ34',
// 		description: 'COYOTE Briquette Set For 34" Gas Grills',
// 		msrp: 239,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3BRIQ36': {
// 		sku: 'C3BRIQ36',
// 		description: 'COYOTE Briquette Set For 36" Gas Grills',
// 		msrp: 369,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3BRIQ42': {
// 		sku: 'C3BRIQ42',
// 		description: 'COYOTE Briquette Set For 42" Gas Grills',
// 		msrp: 489,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3BRIQ50': {
// 		sku: 'C3BRIQ50',
// 		description: 'COYOTE Briquette Set For 50" Gas Grills',
// 		msrp: 289,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3C30CART': {
// 		sku: 'C3C30CART',
// 		description: 'COYOTE Cart for 30" C or SL-Series Grill',
// 		msrp: 799,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3C34CT': {
// 		sku: 'C3C34CT',
// 		description: 'COYOTE Cart For 34" C-Series Grill',
// 		msrp: 899,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3CH36CT': {
// 		sku: 'C3CH36CT',
// 		description: 'COYOTE Cart For 36" Charcoal Grill',
// 		msrp: 999,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3CLSIGRATE36B': {
// 		sku: 'C3CLSIGRATE36B',
// 		description: 'COYOTE Signature Beef Grate For C3CL36',
// 		msrp: 179,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3CLSIGRATE36G': {
// 		sku: 'C3CLSIGRATE36G',
// 		description: 'COYOTE Signature Griddle Grate For C3CL36',
// 		msrp: 179,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3CLSIGRATE36P': {
// 		sku: 'C3CLSIGRATE36P',
// 		description: 'COYOTE Signature Poultry Grate For C3CL36',
// 		msrp: 179,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3CLSIGRATE36V': {
// 		sku: 'C3CLSIGRATE36V',
// 		description: 'COYOTE Signature Vegetable Grate For C3CL36',
// 		msrp: 179,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3CLSIGRATE42B': {
// 		sku: 'C3CLSIGRATE42B',
// 		description: 'COYOTE Signature Beef Grate For C3CL42',
// 		msrp: 199,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3CLSIGRATE42G': {
// 		sku: 'C3CLSIGRATE42G',
// 		description: 'COYOTE Signature Griddle Grate For C3CL42',
// 		msrp: 199,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3CLSIGRATE42P': {
// 		sku: 'C3CLSIGRATE42P',
// 		description: 'COYOTE Signature Poultry Grate For C3CL42',
// 		msrp: 199,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3CLSIGRATE42V': {
// 		sku: 'C3CLSIGRATE42V',
// 		description: 'COYOTE Signature Vegetable Grate For C3CL42',
// 		msrp: 199,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3CSIGRATE30B': {
// 		sku: 'C3CSIGRATE30B',
// 		description: 'COYOTE Signature Beef Grate For C3C30',
// 		msrp: 129,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3CSIGRATE30G': {
// 		sku: 'C3CSIGRATE30G',
// 		description: 'COYOTE Signature Griddle Grate For C3C30',
// 		msrp: 129,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3CSIGRATE30P': {
// 		sku: 'C3CSIGRATE30P',
// 		description: 'COYOTE Signature Poultry Grate For C3C30',
// 		msrp: 129,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3CSIGRATE30V': {
// 		sku: 'C3CSIGRATE30V',
// 		description: 'COYOTE Signature Vegetable Grate For C3C30',
// 		msrp: 129,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3CSIGRATE34B': {
// 		sku: 'C3CSIGRATE34B',
// 		description: 'COYOTE Signature Beef Grate For C3C34',
// 		msrp: 169,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3CSIGRATE34G': {
// 		sku: 'C3CSIGRATE34G',
// 		description: 'COYOTE Signature Griddle Grate For C3C34',
// 		msrp: 169,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3CSIGRATE34P': {
// 		sku: 'C3CSIGRATE34P',
// 		description: 'COYOTE Signature Poultry Grate For C3C34',
// 		msrp: 169,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3CSIGRATE34V': {
// 		sku: 'C3CSIGRATE34V',
// 		description: 'COYOTE Signature Vegetable Grate For C3C34',
// 		msrp: 169,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3FTCART': {
// 		sku: 'C3FTCART',
// 		description: 'COYOTE 30" Flat Top Grill Cart',
// 		msrp: 999,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3HY50CT': {
// 		sku: 'C3HY50CT',
// 		description: 'COYOTE Cart For 50" Hybrid or Combo Grill',
// 		msrp: 1399,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3HZSC30': {
// 		sku: 'C3HZSC30',
// 		description: 'COYOTE Set of Heat Zone Separators For C3C30',
// 		msrp: 79,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3HZSC34': {
// 		sku: 'C3HZSC34',
// 		description: 'COYOTE Set of Heat Zone Separators For C3C34',
// 		msrp: 79,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3ROT30': {
// 		sku: 'C3ROT30',
// 		description: 'Coyote Rotisserie Kit For 30 Inch Grills',
// 		msrp: 349,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3ROT34': {
// 		sku: 'C3ROT34',
// 		description: 'COYOTE Rotisserie Kit For 34" Gas Grills',
// 		msrp: 349,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3ROT36': {
// 		sku: 'C3ROT36',
// 		description: 'COYOTE Rotisserie Kit For 36" Gas Grills',
// 		msrp: 349,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3ROT42': {
// 		sku: 'C3ROT42',
// 		description: 'COYOTE Rotisserie Kit For 42" Gas Grills',
// 		msrp: 349,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3S36CT': {
// 		sku: 'C3S36CT',
// 		description: 'COYOTE Cart For 36" CL or SL-Series Grill',
// 		msrp: 949,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3S42CT': {
// 		sku: 'C3S42CT',
// 		description: 'COYOTE Cart For 42" CL or SL-Series Grill',
// 		msrp: 1199,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3SEARBURNER': {
// 		sku: 'C3SEARBURNER',
// 		description: 'COYOTE Sear Burner For CL & SL Series',
// 		msrp: 159,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3SLSIGRATE30B': {
// 		sku: 'C3SLSIGRATE30B',
// 		description: 'COYOTE Signature Beef Grate For C3SL30',
// 		msrp: 199,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3SLSIGRATE30G': {
// 		sku: 'C3SLSIGRATE30G',
// 		description: 'COYOTE Signature Griddle Grate For C3SL30',
// 		msrp: 199,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3SLSIGRATE30P': {
// 		sku: 'C3SLSIGRATE30P',
// 		description: 'COYOTE Signature Poultry Grate For C3SL30',
// 		msrp: 199,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3SLSIGRATE30V': {
// 		sku: 'C3SLSIGRATE30V',
// 		description: 'COYOTE Signature Vegetable Grate For C3SL30',
// 		msrp: 199,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3SLSIGRATE36B': {
// 		sku: 'C3SLSIGRATE36B',
// 		description: 'COYOTE Signature Beef Grate For C3SL36',
// 		msrp: 179,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3SLSIGRATE36G': {
// 		sku: 'C3SLSIGRATE36G',
// 		description: 'COYOTE Signature Griddle Grate For C3SL36',
// 		msrp: 179,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3SLSIGRATE36V': {
// 		sku: 'C3SLSIGRATE36V',
// 		description: 'COYOTE Signature Vegetable Grate For C3SL36',
// 		msrp: 179,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3SLSIGRATE42B': {
// 		sku: 'C3SLSIGRATE42B',
// 		description: 'COYOTE Signature Beef Grate For C3SL42',
// 		msrp: 199,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3SLSIGRATE42G': {
// 		sku: 'C3SLSIGRATE42G',
// 		description: 'COYOTE Signature Griddle Grate For C3SL42',
// 		msrp: 199,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3SLSIGRATE42P': {
// 		sku: 'C3SLSIGRATE42P',
// 		description: 'COYOTE Signature Poultry Grate For C3SL42',
// 		msrp: 199,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3SLSIGRATE42V': {
// 		sku: 'C3SLSIGRATE42V',
// 		description: 'COYOTE Signature Vegetable Grate For C3SL42',
// 		msrp: 199,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'CCHTRAY12': {
// 		sku: 'CCHTRAY12',
// 		description: 'Coyote Charcoal Trays 1 pc - Coyote Charcoal Trays 1 pc - Compatible with C1C34, C1C36, C1SL36, C2C34, C2C36, & C2SL36 Grills',
// 		msrp: 169,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'CCHTRAY15': {
// 		sku: 'CCHTRAY15',
// 		description: 'Coyote Charcoal Trays 1 pc - Compatible with C1C28, C2SL30, C1C42, C1SL42, C2C42, C2SL42 Grill',
// 		msrp: 169,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'CCVR28P-BIG': {
// 		sku: 'CCVR28P-BIG',
// 		description: 'Coyote Cover for 28" BI Pellet grill (Gray)',
// 		msrp: 99,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'CCVR3-BIG': {
// 		sku: 'CCVR3-BIG',
// 		description: 'Coyote Cover for 34"',
// 		msrp: 99,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'CCVR3-CTG': {
// 		sku: 'CCVR3-CTG',
// 		description: 'Coyote Cover for 34" on cart',
// 		msrp: 149,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'CCVR36-BIG': {
// 		sku: 'CCVR36-BIG',
// 		description: 'Coyote Cover for 36" (For Built-In Grill)',
// 		msrp: 99,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'CCVR36-CTG': {
// 		sku: 'CCVR36-CTG',
// 		description: 'Coyote Cover for 36" on cart',
// 		msrp: 149,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'CCVR36P-BIG': {
// 		sku: 'CCVR36P-BIG',
// 		description: 'Coyote Cover for 36" Pellet Grill (For Built-In Grill)',
// 		msrp: 109,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'CCVR42-BIG': {
// 		sku: 'CCVR42-BIG',
// 		description: 'Coyote Cover for 42"',
// 		msrp: 99,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'CCVR42-CTG': {
// 		sku: 'CCVR42-CTG',
// 		description: 'Coyote Cover for 42" on cart',
// 		msrp: 179,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'CCVR50-BIG': {
// 		sku: 'CCVR50-BIG',
// 		description: 'Coyote Cover for built in 50" Grill (GRAY)',
// 		msrp: 99,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'CCVR50-CTG': {
// 		sku: 'CCVR50-CTG',
// 		description: 'Coyote Gray Cover For 50" Freestanding Gas Grills',
// 		msrp: 199,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'CCVRDB-BIG': {
// 		sku: 'CCVRDB-BIG',
// 		description: 'Coyote Cover for Coyote Double Side Burner',
// 		msrp: 59,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'CCVREL-BIG': {
// 		sku: 'CCVREL-BIG',
// 		description: 'Coyote Electric Grill Cover for Built in Grill',
// 		msrp: 59,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'CCVRFT-BIG': {
// 		sku: 'CCVRFT-BIG',
// 		description: 'Coyote Cover for built in Flattop Grill',
// 		msrp: 79,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'CCVRFT-CTG': {
// 		sku: 'CCVRFT-CTG',
// 		description: 'Coyote Cover for Free Standing Flattop Grill',
// 		msrp: 129,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'CCVRPB-BIG': {
// 		sku: 'CCVRPB-BIG',
// 		description: 'Coyote Cover for Power Burner (For Built-In Power Burner) (Gray)',
// 		msrp: 69,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'CCVRPG-CTG': {
// 		sku: 'CCVRPG-CTG',
// 		description: 'Coyote Cover For Portable Grill',
// 		msrp: 39,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'CCVRSB-BIG': {
// 		sku: 'CCVRSB-BIG',
// 		description: 'Coyote Cover for Coyote Single Side Burner',
// 		msrp: 59,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'CINLNREG': {
// 		sku: 'CINLNREG',
// 		description: 'Coyote In-Line LP/NG Regulator',
// 		msrp: 79,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'CINLNREGHOSE': {
// 		sku: 'CINLNREGHOSE',
// 		description: '16" Extension Hose for CINLNREG',
// 		msrp: 79,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'CLPREG': {
// 		sku: 'CLPREG',
// 		description: 'Coyote LP Regulator Kit',
// 		msrp: 79,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'CNGREG': {
// 		sku: 'CNGREG',
// 		description: 'Coyote NG Regulator Kit',
// 		msrp: 79,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'COYVENT': {
// 		sku: 'COYVENT',
// 		description: 'Coyote Vent for Island (2 pk)',
// 		msrp: 79,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'CSBX': {
// 		sku: 'CSBX',
// 		description: 'Coyote Smoker Box',
// 		msrp: 69,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'CSTUBE': {
// 		sku: 'CSTUBE',
// 		description: 'Coyote Smoker Tube For Pellet Grill',
// 		msrp: 29,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'CTEP': {
// 		sku: 'CTEP',
// 		description: 'Coyote Teppanyaki Griddle Accessory',
// 		msrp: 559,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'CWOK': {
// 		sku: 'CWOK',
// 		description: 'Coyote Wok Accessory',
// 		msrp: 149,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C1PZ30LP2NG': {
// 		sku: 'C1PZ30LP2NG',
// 		description: 'COYOTE C1PZ30 LP to NG Conversion Kit',
// 		msrp: 259,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C1PZ30NG2LP': {
// 		sku: 'C1PZ30NG2LP',
// 		description: 'COYOTE C1PZ30 NG to LP Conversion Kit',
// 		msrp: 259,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3C30LP2NG': {
// 		sku: 'C3C30LP2NG',
// 		description: 'COYOTE C3C30 LP to NG Conversion Kit',
// 		msrp: 179,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3C30NG2LP': {
// 		sku: 'C3C30NG2LP',
// 		description: 'COYOTE C3C30 NG to LP Conversion Kit',
// 		msrp: 179,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3FTLP2NG': {
// 		sku: 'C3FTLP2NG',
// 		description: 'COYOTE C3FTG30 LP To NG Conversion Kit',
// 		msrp: 179,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3FTNG2LP': {
// 		sku: 'C3FTNG2LP',
// 		description: 'COYOTE C3FTG30 NG to LP Conversion Kit',
// 		msrp: 179,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3LP2NG': {
// 		sku: 'C3LP2NG',
// 		description: 'COYOTE CL & SL Series LP To NG Conversion Kit',
// 		msrp: 319,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'C3NG2LP': {
// 		sku: 'C3NG2LP',
// 		description: 'COYOTE CL & SL Series NG To LP Conversion Kit',
// 		msrp: 319,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'RTAC-C3-Cover': {
// 		sku: 'RTAC-C3-Cover',
// 		description: 'RTA Heavy Duty Weather Max Custom Island Cover for 3FT Islands',
// 		msrp: 395,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'RTAC-C4-Cover': {
// 		sku: 'RTAC-C4-Cover',
// 		description: 'RTA Heavy Duty Weather Max Custom Island Cover for 4FT Islands',
// 		msrp: 395,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'RTAC-C5-Cover': {
// 		sku: 'RTAC-C5-Cover',
// 		description: 'RTA Heavy Duty Weather Max Custom Island Cover for 5FT Islands',
// 		msrp: 395,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'RTAC-C6-Cover': {
// 		sku: 'RTAC-C6-Cover',
// 		description: 'RTA Heavy Duty Weather Max Custom Island Cover for 6FT Islands',
// 		msrp: 435,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'RTAC-C7-Cover': {
// 		sku: 'RTAC-C7-Cover',
// 		description: 'RTA Heavy Duty Weather Max Custom Island Cover for 7FT Islands',
// 		msrp: 475,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'RTAC-C8-Cover': {
// 		sku: 'RTAC-C8-Cover',
// 		description: 'RTA Heavy Duty Weather Max Custom Island Cover for 8FT Islands',
// 		msrp: 525,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'RTAC-C9-Cover': {
// 		sku: 'RTAC-C9-Cover',
// 		description: 'RTA Heavy Duty Weather Max Custom Island Cover for 9FT Islands',
// 		msrp: 555,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'RTAC-C10-Cover': {
// 		sku: 'RTAC-C10-Cover',
// 		description: 'RTA Heavy Duty Weather Max Custom Island Cover for 10FT Islands',
// 		msrp: 595,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'RTAC-C11-Cover': {
// 		sku: 'RTAC-C11-Cover',
// 		description: 'RTA Heavy Duty Weather Max Custom Island Cover for 11FT Islands',
// 		msrp: 635,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'RTAC-C12-Cover': {
// 		sku: 'RTAC-C12-Cover',
// 		description: 'RTA Heavy Duty Weather Max Custom Island Cover for 12FT Islands',
// 		msrp: 685,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'RTAC-C13-Cover': {
// 		sku: 'RTAC-C13-Cover',
// 		description: 'RTA Heavy Duty Weather Max Custom Island Cover for 13FT Islands',
// 		msrp: 715,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'RTAC-C14-Cover': {
// 		sku: 'RTAC-C14-Cover',
// 		description: 'RTA Heavy Duty Weather Max Custom Island Cover for 14FT Islands',
// 		msrp: 755,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'RTAC-C15-Cover': {
// 		sku: 'RTAC-C15-Cover',
// 		description: 'RTA Heavy Duty Weather Max Custom Island Cover for 15FT Islands',
// 		msrp: 795,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	},
// 	'RTAC-C16-Cover': {
// 		sku: 'RTAC-C16-Cover',
// 		description: 'RTA Heavy Duty Weather Max Custom Island Cover for 16FT Islands',
// 		msrp: 835,
// 		pairedAppliance: [],
// 		searchTerm: 'Accessory'
// 	}
// };

